import React from 'react';

// Utility function to safely handle dynamic Tailwind classes
const classNames = (...classes) => classes.filter(Boolean).join(' ');

const ButtonBar = ({ title, buttons, viewToggle, extraContent }) => {
  // Map of allowed button colors to their Tailwind classes
  const colorClasses = {
    purple: 'bg-purple-600 hover:bg-purple-700',
    blue: 'bg-blue-500 hover:bg-blue-600',
    red: 'bg-red-500 hover:bg-red-600',
    green: 'bg-green-500 hover:bg-green-600',
    emerald: 'bg-emerald-500 hover:bg-emerald-600',
    slate: 'bg-slate-600 hover:bg-slate-700',
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow border border-gray-200 mb-4">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <h2 className="text-2xl font-semibold text-gray-800">
          {title}
        </h2>
        <div className="flex items-center gap-3 flex-wrap">
          {viewToggle && (
            <div className="flex items-center">
              {viewToggle}
            </div>
          )}
          <div className="flex items-center gap-2 flex-wrap">
            {buttons.map((button, index) => (
              <button
                key={index}
                className={classNames(
                  colorClasses[button.color] || colorClasses['blue'],
                  'text-white font-semibold py-2 px-4 rounded-lg text-sm transition-all duration-200 hover:shadow-md active:scale-95 whitespace-nowrap'
                )}
                onClick={button.onClick}
              >
                {button.label}
              </button>
            ))}
            {extraContent}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ButtonBar;
